import api from './index';
import { Location } from '../types/Location.interface';

const BASE = '/location';

export const getAllLocations = async () => {
    return api.get<Location[]>(`${BASE}`).then((res) => res.data);
};
